import { Paginated, Timestamps, Versioned } from './shared.types';

export enum DailyCountItemStatus {
  PENDING = 'PENDING',
  COUNTED = 'COUNTED',
  CARRIED_OVER = 'CARRIED_OVER',
}

export interface DailyCountAuditEntry {
  counted_by: string;
  counted_by_name: string;
  counted_stock: number;
  expected_stock: number;
  counted_at: string;
  recount_reason?: string;
}

export interface DailyCountItem {
  product_id: string;
  product_name: string;
  status: DailyCountItemStatus;
  expected_stock: number | null;
  counted_stock: number | null;
  counted_by: string | null;
  counted_by_name: string | null;
  counted_at: string | null;
  carried_from_date: string | null;
  is_short: boolean;
  recount_reason?: string;
  count_audit?: DailyCountAuditEntry[];
}

export interface DailyCountList extends Timestamps, Versioned {
  id: string;
  store_id: string;
  merchant_id: string;
  count_date: string;
  items: DailyCountItem[];
  generated_at: string;
  target_count: number;
  fresh_count: number;
  carried_over_count: number;
}

export interface DailyCountListPage extends Paginated {
  daily_count_lists: DailyCountList[];
}

export interface RecordDailyCount {
  store_id: string;
  count_date: string;
  product_id: string;
  counted_by: string;
  counted_stock: number;
  expected_stock: number;
  recount_reason?: string;
}

export interface GetDailyCountLists {
  store_id: string;
  merchant_id: string;
  date?: string;
  start_date?: string;
  end_date?: string;
  limit?: number;
  cursor?: string;
}

export interface TriggerDailyCountList {
  store_id: string;
  /** When true, replaces today's list even if one already exists. */
  force?: boolean;
  /**
   * When true, the generated list ignores carry-over from yesterday and is
   * built only from freshly-selected products. Used by the manual "Reset"
   * action so the operator gets a clean slate regardless of the store's
   * daily_count_carry_over_enabled flag.
   */
  fresh?: boolean;
}

export interface DailyCountListDBItem extends DailyCountList {
  /**
   * PK: STORE#{store_id}
   * SK: DAILY_COUNT#DATE#{count_date}
   * GSI1PK: DAILY_COUNT#MERCHANT#{merchant_id}
   * GSI1SK: DATE#{count_date}#STORE#{store_id}
   * EntityIndexPK: DAILY_COUNT
   * EntityIndexSK: MERCHANT#{merchant_id}#DATE#{count_date}
   */
  PK: string;
  SK: string;
  GSI1PK: string;
  GSI1SK: string;
  EntityIndexPK: string;
  EntityIndexSK: string;
}
